import { getSettingDetail } from "../api/discount.service";
import { useEffect, useState } from "react";
import EditSettingModal from "../components/forms/setting/EditSettingModal";

function Settings() {

  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [vehicleData, setVehicleData] = useState(null);
  const [isViewOnly, setisViewOnly] = useState(false);

  const getVehicleData = async (isViewOnly = false) => {
    setisViewOnly(isViewOnly)
    const data = await getSettingDetail();
    setVehicleData(data.data);
    setIsModalOpenEdit(true);
  }

  useEffect(() => {
    getVehicleData(false)
  }, [])

  const handleOkEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleCancelEdit = () => {
    setIsModalOpenEdit(false);
  };

  return (
    <>
      {vehicleData && <EditSettingModal isViewOnly={isViewOnly} vehicleData={vehicleData} handleCancel={handleCancelEdit} handleOk={handleOkEdit} isModalOpen={isModalOpenEdit} setIsModalOpen={setIsModalOpenEdit} />}
    </>
  );
}

export default Settings;
